/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Статус заявок на Day Off
 */
export enum DayOffApplicationStatus {
    PENDING = 'pending',
    ORDER_SIGNING = 'order_signing',
    ORDER_SIGNED = 'order_signed',
    CONFIRMED_BY_USER = 'confirmed_by_user',
    ACTIVE = 'active',
    COMPLETED = 'completed',
    CANCELED = 'canceled',
}
